module.exports = __webpack_public_path__ + "static/media/infinity.5e048133.svg";